module.exports = __webpack_public_path__ + "static/media/599.705493(6).5fbe7041.pdf";